import { IAuthState, AuthStates } from "./types";

export const initialState: IAuthState = {
  state: AuthStates.SIGNED_IN
};
